import React from 'react'

export default function AvatarCircleIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path fillRule="evenodd" d="M7.6 1.3a11.5 11.5 0 1 1 8.9 21.4A11.5 11.5 0 0 1 7.6 1.3Zm4.4.2a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21Z" clipRule="evenodd"/>
            <path fillRule="evenodd" d="M12 7.6a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm-3.8 3a3.7 3.7 0 1 1 7.5 0 3.7 3.7 0 0 1-7.5 0Zm3.8 6.8c-2.5 0-4.8 1-6.5 2.9l-.2.2-.6-.5.3-.3a9.6 9.6 0 0 1 14 0l.3.3-.6.5-.2-.2a8.9 8.9 0 0 0-6.5-3Z" clipRule="evenodd"/>
        </svg>
    )
}